import { Box, Typography, useTheme } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import { Button } from '../ui/button';

export const ContractDetailSellerSuccess = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { contractId } = useParams();
  return (
    <Box
      sx={{
        py: '40px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <i
        className="fa-light fa-badge-check"
        style={{ color: theme.palette.success.main, fontSize: '96px' }}
      />
      <Typography variant="h2" sx={{ mt: 4 }}>
        Information Submitted!
      </Typography>
      <Typography variant="body1" sx={{ mt: 4, lineHeight: '24px' }}>
        Thank you for submitting your information.
        <br />
        <br />
        <strong>Next Steps:</strong>
        <br />
        1. Review and negotiate contract terms with the buyer
        <br />
        2. After all negotiations are complete, you'll sign the contract
        <br />
        3. We'll notify you when the contract is ready for your signature
      </Typography>
      <Box
        sx={{
          mt: 4,
          display: 'flex',
          gap: 2,
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}
      >
        <Button
          className="items-center"
          variant="default"
          onClick={() => navigate(`/seller/negotiate/${contractId}`)}
        >
          Go to Negotiations
        </Button>
        <Button
          className="items-center"
          variant="outline"
          onClick={() => navigate(`/view-contract/${contractId}`)}
        >
          View Contract
        </Button>
      </Box>
    </Box>
  );
};
